import { render, staticRenderFns } from "./CaseElement.vue?vue&type=template&id=ecdb6858&scoped=true&"
import script from "./CaseElement.vue?vue&type=script&lang=js&"
export * from "./CaseElement.vue?vue&type=script&lang=js&"
import style0 from "./CaseElement.vue?vue&type=style&index=0&id=ecdb6858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdb6858",
  null
  
)

export default component.exports